var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.message != null && _vm.message.length > 0)?_c('div',{staticClass:"tempdata alert alert-primary Message-Info Info Message-Info"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }